// @ts-expect-error: implicitly has an 'any' type
import buildLocalizeFn from 'date-fns/locale/_lib/buildLocalizeFn';
import enUsLocale from 'date-fns/locale/en-US';

const defaultMonthValues = [
  'ጃንዩወሪ',
  'ፌብሩወሪ',
  'ማርች',
  'ኤፕሪል',
  'ሜይ',
  'ጁን',
  'ጁላይ',
  'ኦገስት',
  'ሴፕቴምበር',
  'ኦክቶበር',
  'ኖቬምበር',
  'ዲሴምበር',
];

const abbreviatedMonthValues = [
  'ጃንዩ',
  'ፌብሩ',
  'ማርች',
  'ኤፕሪ',
  'ሜይ',
  'ጁን',
  'ጁላይ',
  'ኦገስ',
  'ሴፕቴ',
  'ኦክቶ',
  'ኖቬም',
  'ዲሴም',
];

const monthValues = {
  narrow: abbreviatedMonthValues,
  abbreviated: abbreviatedMonthValues,
  wide: defaultMonthValues,
};

const defaultDayValues = ['እሑድ', 'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'ዓርብ', 'ቅዳሜ'];

const abbreviatedDayValues = ['እሑድ', 'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'ዓርብ', 'ቅዳሜ'];

const dayValues = {
  narrow: abbreviatedDayValues,
  short: abbreviatedDayValues,
  abbreviated: abbreviatedDayValues,
  wide: defaultDayValues,
};

const defaultDayPeriodValues = {
  am: 'ጥዋት',
  pm: 'ከሰዓት',
  midnight: 'እኩለ ሌሊት',
  noon: 'ቀትር',
  morning: 'ጥዋት1',
  afternoon: 'ከሰዓት በኋላ',
  evening: 'ማታ',
  night: 'ሌሊት',
};

const abbreviatedDayPeriodValues = {
  ...defaultDayPeriodValues,
  am: 'ጥዋት',
  pm: 'ከሰዓት',
};

const dayPeriodValues = {
  narrow: abbreviatedDayPeriodValues,
  abbreviated: abbreviatedDayPeriodValues,
  wide: defaultDayPeriodValues,
};

const defaultFormattingDayPeriodValues = {
  am: 'ጥዋት',
  pm: 'ከሰዓት',
  midnight: 'እኩለ ሌሊት',
  noon: 'ቀትር',
  morning: 'ጥዋት1',
  afternoon: 'ከሰዓት በኋላ',
  evening: 'ማታ',
  night: 'ሌሊት',
};

const abbreviatedFormattingDayPeriodValues = {
  ...defaultFormattingDayPeriodValues,
  am: 'ጥዋት',
  pm: 'ከሰዓት',
};

const formattingDayPeriodValues = {
  narrow: abbreviatedFormattingDayPeriodValues,
  abbreviated: abbreviatedFormattingDayPeriodValues,
  wide: defaultFormattingDayPeriodValues,
};

export const localize: Locale['localize'] = {
  ordinalNumber: enUsLocale.localize!.ordinalNumber,
  era: enUsLocale.localize!.era,
  quarter: enUsLocale.localize!.quarter,
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide',
  }),
};
